var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotes = function SvgNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "notes_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9 10.9h22.4v20.2H9.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2 31.1v-2.6H13.8v2.6zM32.2 25.2v-2.6H13.8v2.6zM32.2 19.4v-2.6H13.8v2.6zM11.1 19.4c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3c.7.1 1.2.6 1.2 1.3.1.7-.5 1.3-1.2 1.3zM32.2 13.5v-2.6H13.8v2.6zM11.1 13.5c-.7 0-1.3-.6-1.2-1.3 0-.7.6-1.3 1.3-1.3.7.1 1.2.6 1.2 1.3 0 .8-.6 1.3-1.3 1.3zM11.1 25.3c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3c.7.1 1.2.6 1.2 1.3.1.7-.5 1.3-1.2 1.3zM11.1 31.1c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3c.7.1 1.2.6 1.2 1.3.1.8-.5 1.4-1.2 1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.2 2.4v37.1h33.5V2.4zM35.5 37h-29V5h29z"
  }))));
};
export default SvgNotes;